import { masterApi } from './api';

export default async function fetchMarketplacesData({ accessToken }) {
	const res = await masterApi.get('/marketplacecountryvista', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	return res?.data;
}
